// Building blocks for the human auth lane (ADR-0060). The Worker brokers Google
// sign-in itself and returns the browser to a same-origin path with an Owner Session
// cookie set; the SPA just needs to send the browser to `/auth/login` with the right
// `returnTo`. Sign-in is a **full-page navigation** (not the SPA `navigate`) because it
// leaves the origin for Google and comes back — client-side history can't carry it.
//
// The URL construction is a pure function (host-tested); the navigation is the one
// side-effecting line, injected in components so jsdom is never asked to navigate.

/** Build the `/auth/login` URL that returns to `returnTo` (same-origin path) after sign-in. */
export function authLoginUrl(returnTo: string): string {
  return `/auth/login?returnTo=${encodeURIComponent(returnTo)}`;
}

/** Kick off Google sign-in: a full-page navigation to `/auth/login` (leaves the SPA). */
export function startLogin(returnTo: string): void {
  window.location.assign(authLoginUrl(returnTo));
}
